import React, {
    CSSProperties,
    ChangeEvent,
    Dispatch,
    PropsWithChildren,
    SetStateAction,
    useContext,
    useState,
} from 'react';

import { SearchBox, ISearchBoxStyles } from '@fluentui/react';
import { ThemeContext } from '../../../HubLayout/models/ThemeContext';
import {
    getThemeFromString,
    setMultiStageReleaseSearchValueInLocalStorage,
} from '../../../Common/util/localStorageUtils';

interface IMultiStageReleaseSearchProps extends PropsWithChildren<any> {
    searchValue?: string;
    setSearchValue?: Dispatch<SetStateAction<string | undefined>>;
    setSearchQuery?: Dispatch<SetStateAction<string | undefined>>;
    setPageNumber?: Dispatch<SetStateAction<number>>;
    isLoaded: boolean;
    isMobile?: boolean;
    placeholder?: string;
    alignToGrid?: boolean;
    gridColumn?: CSSProperties['gridColumn'];
}

export const MultiStageReleaseSearch: React.FC<IMultiStageReleaseSearchProps> =
    (props: IMultiStageReleaseSearchProps) => {
        const themeContext = useContext(ThemeContext);
        const theme = getThemeFromString(themeContext.themeName);
        const [disabled, setDisabled] = useState<boolean>(false);

        const handleKeyDown = (
            event: React.KeyboardEvent<HTMLInputElement>
        ) => {
            props.setSearchQuery?.(props.searchValue);
        };

        const onChange = (
            event: ChangeEvent<HTMLInputElement> | undefined,
            newValue?: string | undefined
        ) => {
            props.setSearchValue?.(newValue);
            if (newValue === '') {
                props.setSearchQuery?.(newValue);
            }
        };

        const onClear = () => {
            props.setPageNumber?.(1);
            props.setSearchValue?.('');
            props.setSearchQuery?.('');
            setMultiStageReleaseSearchValueInLocalStorage('');
        };

        const divStyles: CSSProperties = {
            display: 'flex',
            margin: props.alignToGrid ? 0 : '6px',
            flexGrow: 1,
            width: props.isMobile ? '100%' : undefined,
            gridColumn: props.gridColumn,
        };

        const searchBoxStyles: Partial<ISearchBoxStyles> = {
            root: {
                border: 'none',
                width: '100%',
                backgroundColor: theme.palette.neutralLighter,
                fontWeight: props.searchValue === '' ? 'normal' : 'bold',
            },
        };

        return (
            <div style={divStyles}>
                <SearchBox
                    styles={searchBoxStyles}
                    placeholder={
                        props.placeholder ||
                        'Search All Releases by Name, Id, Project or Component Name'
                    }
                    ariaLabel="Search releases"
                    onClear={onClear}
                    onChange={onChange}
                    onSearch={handleKeyDown}
                    value={props.searchValue}
                    disableAnimation={true}
                    showIcon={true}
                    disabled={disabled}
                />
            </div>
        );
    };
